import { createI18n } from 'vue-i18n'
import VueCookies from 'vue-cookies'

// element-plus langs
import elementCnLocale from 'element-plus/es/locale/lang/zh-cn'
import elementEnLocale from 'element-plus/es/locale/lang/en'
import elementEsLocale from 'element-plus/es/locale/lang/es'
import elementRoLocale from 'element-plus/es/locale/lang/ro'
import elementRuLocale from 'element-plus/es/locale/lang/ru'
import elementUaLocale from 'element-plus/es/locale/lang/uk'
import elementKzLocale from 'element-plus/es/locale/lang/kk'

// UI locales
// import azLocale from './az'
// import byLocale from './by'
// import cnLocale from './cn'
import enLocale from './en'
// import esLocale from './es'
// import roLocale from './ro'
import ruLocale from './ru'
// import ukLocale from './uk'
// import kkLocale from './kk'

export const messages = {
  az: {
    ...elementEnLocale, // use english
    // ...azLocale,
    fullName: 'Azərbaycan'
  },
  by: {
    ...elementRuLocale, // use russian
    // ...byLocale,
    fullName: 'Беларускі'
  },
  cn: {
    ...elementCnLocale,
    // ...cnLocale,
    fullName: '中國人'
  },
  en: {
    ...elementEnLocale,
    ...enLocale,
    fullName: 'English'
  },
  es: {
    ...elementEsLocale,
    // ...esLocale,
    fullName: 'Español'
  },
  kz: {
    ...elementKzLocale,
    // ...kzLocale,
    fullName: 'Қазақ'
  },
  ro: {
    ...elementRoLocale,
    // ...roLocale
    fullName: 'Română'
  },
  ru: {
    ...elementRuLocale,
    ...ruLocale,
    fullName: 'Русский'
  },
  ua: {
    ...elementUaLocale,
    // ...uaLocale,
    fullName: 'Українська мова'
  }
}

export const localeCodes = Object.keys(messages)
export const localesNamesMap = {}
for (const localeCode in messages) {
  localesNamesMap[localeCode] = messages[localeCode].fullName
}

// force locale to en. remove line if multilang is needed
VueCookies.set('locale', 'ru', -1, '/')

if (!VueCookies.isKey('locale')) {
  VueCookies.set('locale', 'ru', -1, '/')
}
const locale = VueCookies.get('locale')

const i18n = createI18n({
  locale,
  messages,
  fallbackLocale: 'en'
})

export default i18n
